import React  from "react";
import { useParams } from "react-router-dom";
import AssetManagementForm from "./components/AssetManagementForm";
import AssetLocationHistoryTable from "./components/AssetLocationHistoryTable";

const ViewAsset = ()  => {
	const { recordId } = useParams();

	return (
		<div className="space-y-6">
			<div className="dark-mode-card p-3 border-2 dark:border-gray-700 rounded-2xl">
				<AssetManagementForm
					recordId={recordId}
					mode="view"
				/>
			</div>
			<AssetLocationHistoryTable     
				recordId={recordId}
			/>
		</div>

    );
};

export default ViewAsset;